import * as Factory from 'factory.ts'
import * as faker from 'faker'

import type { InstanceManagementAPIResponse } from '@webapp/api/instanceManagement/client'
import { InstanceManagementCompanyStages } from '@webapp/models/enums/InstanceManagementCompanyStage'

export const InstanceManagementInstanceMock =
  Factory.Sync.makeFactory<InstanceManagementAPIResponse>({
    domain: Factory.each(() => faker.internet.domainName()),
    company_name: Factory.each(() => faker.company.companyName()),
    implementation_manager: Factory.each(() => faker.internet.email()),
    customer_stage: InstanceManagementCompanyStages.ONBOARDING,
  })
